import { useSyncExternalStore } from "react";

const listeners = new Set<() => void>();

let resolvedOrganizationId: string | undefined;

function subscribe(listener: () => void) {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}

export function markFlagContextResolved(organizationId: string) {
    if (resolvedOrganizationId === organizationId) {
        return;
    }

    resolvedOrganizationId = organizationId;
    listeners.forEach(listener => listener());
}

export function resetFlagContextResolution() {
    resolvedOrganizationId = undefined;
    listeners.forEach(listener => listener());
}

export function useIsFlagContextResolved(organizationId: string | undefined) {
    return useSyncExternalStore(subscribe, () => organizationId !== undefined && resolvedOrganizationId === organizationId);
}
